let language = {
    REGIST_INTRO_TITLE: "QP合作伙伴计划注册",
    REGIST_INTRO_1: "使用{{appName}}可靠的印刷服务自信地开始您的电子商务业务",
    REGIST_INTRO_2: "体验适合您的电子商务业务的终极直销解决方案",
    REGIST_INTRO_3: "加入 {{appName}} 社区，将您的想法变成现实。",
};

export { language }